import { Box, Button, CircularProgress, FormControl, Grid, styled, TextField, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { createGameFact } from "../../../actions/gameFact.js";
import { updateMatch } from "../../../actions/matchs.js";
import {    
            GAME_FACT_ESSAI, 
            GAME_FACT_RUGBY_STOP, 
            GAME_FACT_SOCCER_STOP, 
            GAME_FACT_START } from "../gameFact/constants.js";

import { useScoreResolver } from "../header/useScoreResolver.js";
import { useTimer } from "../header/useTimer.js";
import { getGameFactDetail } from "../saisierapide/utils.js";
import { getTotalTimer } from "../sports/rules.js";
import { debounce } from 'lodash';
import { autoScore, getScoreTypes } from "../utils/autoScore.js";

import {autoScoreGameFact} from '../../../api'
import { usePeriodButton } from "./useMultiplexPeriodButton.js";
import { useButtonTimer } from "./useMultiplexButtonTimer.js";
import { formatRoundLabel } from "../utils/helpers.js";

const LiveMultiplexScore = ({matchs}) => {

    // On retire les matchs dont aucune equipe n'est en subscription 4
    return matchs &&
    Object.entries(matchs)
    .map(([discipline, competitions]) => (
        discipline &&
          Object.entries(competitions).map(([competitionId, matches]) => (
            <Grid item xs={12} sx={{paddingLeft : 1}} key={competitionId}>
              {Object.entries(matches).map(([day, dayMatches]) => <>
              <Typography variant="overline" component="span" sx={{fontSize : '1.4em', fontWeight : 'bold'}}>{matches[Object.keys(matches)[0]][0].competition.name},</Typography><Typography component="span" sx={{fontSize : '1em', fontStyle : 'italic', fontWeight : 'bold'}}>{formatRoundLabel(day)}.</Typography>
                {dayMatches
                    .filter(m => m.homeTeam.subscription === 4 || m.awayTeam.subscription === 4)
                    .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime))
                    .map((match) => (
                    <MatchInMultiplexScore match={match} key={match.idMatch}/>
                  ))}
                  </>)}
            </Grid>
          ))
    ))

}



const MatchInMultiplexScore = React.memo(({match}) => {

    const Item = styled(Box)(({ theme }) => ({
        ...theme.typography.body2,
        textAlign: 'center',
        verticalAlign: 'middle',
        height : '100%', 
        display : 'flex', 
        alignItems:'center', 
        justifyContent : 'center',
        color: theme.palette.text.secondary,
      })); 

      const dispatch = useDispatch()

      const [loadingScore, setLoadingScore] = useState(false)

      const [homeScore, awayScore] = useScoreResolver(match)

      const [homeEssais, awayEssais] = useMemo(() => {
        let homeCount = match.gameFacts.filter(g => g.type === GAME_FACT_ESSAI && g.detail.team === match.homeTeam._id).length
        let awayCount = match.gameFacts.filter(g => g.type === GAME_FACT_ESSAI && g.detail.team === match.awayTeam._id).length

        return [homeCount, awayCount]
      }, [match])

      const [
        timerValue, 
        updateTimer, 
        timerId, 
        startMatch, 
        stopFirstPeriod, 
        startSecondPeriod, 
        stopSecondPeriod, 
        periodValue,
        stopSecondPeriodToNext,
        startPeriod,
        stopPeriod
    ] = useTimer(match, false)
    
      const [localTimer, setLocalTimer] = useState(match.timer)

    useEffect(() => {
        setLocalTimer(timerValue)

    }, [timerValue])

    const handleChangeScoreDebounced = debounce(async (name, value, valuedEssais) => {
        // En fonction du name on résoud l'équipe et on appelle l'autoScore
        setLoadingScore(true)
        let team
        let essais
        if(['homeScore', 'homeEssais'].includes(name)){
            team = match.homeTeam
            essais = valuedEssais ?? homeEssais
        }else if(['awayScore', 'awayEssais'].includes(name)){
            team = match.awayTeam
            essais = valuedEssais ?? awayEssais
        }

        // On supprime tous les fait de jeu de score
        // On récupère les type à supprimer
        const typesToDelete = getScoreTypes(match.discipline)

        const deleteInfo = {types : typesToDelete, idTeam : team._id}
        //typesToDelete.forEach(type => dispatch(deleteGameFacts(match, team, type)))

        const gameFacts = autoScore(match.discipline, team, value, essais)

        const createInfo = gameFacts.filter(g => g.count).map(g => {
            const {gameFactDetail, count, type} = g
            const newGameFact = {}
            newGameFact.detail = gameFactDetail
            newGameFact.creation = Date.now()
            newGameFact.idMatch = match.idMatch
            newGameFact.type = type
            newGameFact.detail.edited = false
            return {
                newGameFact,
                count
            }
        })


        await autoScoreGameFact(deleteInfo, createInfo, match.idMatch)

        setLoadingScore(false)

    }, 1000)

    const handleChangeScore = (e) => {
        const {name, value, defaultValue} = e.target

        // Convertir la valeur en nombre
        const numericValue = parseInt(value, 10);

        // S'assurer que la valeur est un nombre, n'est pas NaN, et est dans la plage de 0 à 300
        if (name && !isNaN(numericValue) && numericValue >= 0 && numericValue <= 300) {
            // Appeler la fonction debounced avec la valeur ajustée
            handleChangeScoreDebounced(name, numericValue);
        }
    }

    const handleChangeEssais = (e) => {
        const {name, value, defaultValue} = e.target

        // Convertir la valeur en nombre
        const numericValue = parseInt(value, 10);

        // S'assurer que la valeur est un nombre, n'est pas NaN, et est dans la plage de 0 à 300
        if (name && !isNaN(numericValue) && numericValue >= 0) {
            if(name === 'homeEssais' && numericValue <= homeScore/5){
                handleChangeScoreDebounced('homeScore', homeScore, numericValue)
            }else if(name === 'awayEssais' && numericValue <= awayScore/5){
                handleChangeScoreDebounced('awayScore', awayScore, numericValue)
            }
        }    
    }

    const saveGameFact = (gameFact, team, defaultDetail) => {
        const getDetails = getGameFactDetail(gameFact)

        if(getDetails){
            const gfDetails = getDetails(match, team, undefined, defaultDetail)
            dispatch(createGameFact(gfDetails, gameFact.id, match))
        }
            
    }

    const getPeriodButton = usePeriodButton({match, timerValue, saveGameFact, stopPeriod, startPeriod})

    const pressTimerButton = () => {
        return
        if(match.period !== 2 && (timerValue !== 0))
            updateTimer((...params) => dispatch(updateMatch(...params, undefined, true)))
    }

    const getTimer = useButtonTimer({match, timerValue})

    const getColorButton = useCallback(() => {
        return match.statusTimer === 'on'? 'success' : 'error'
    }, [match.statusTimer])

      return (
        <Box sx={{mb : 3}} key={match.idMatch}>
          <Box sx={{background : 'white'}}>
            <Grid container >
                <Grid item xs={3.5} sx={{overflow : 'hidden'}}>
                    <Item sx={{background : match.homeTeam.color, color : match.homeTeam.textColor, display : 'flex', flexDirection : 'row', justifyContent : 'space-around'}}>
                        <Grid container sx={{alignItems : 'center'}}> 
                            
                            <Grid item xs={9}>
                                <Typography gutterBottom component="div" variant={'body2'}>{match.homeTeam.name}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                {match.homeTeam.logoUrl && <img src={match.homeTeam.logoUrl} style={{height : '30px'}}></img>}
                            </Grid>
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={5}>
                    <Box sx={{display : 'flex', flexDirection : 'column'}}>
                        <Item sx={{background : '#4973AE', color : 'white'}}>
                                {loadingScore ? <CircularProgress/> :<Box sx={{mt : 1, mb : 1}}><TextField 
                                    name="homeScore" 
                                    variant="outlined"
                                    defaultValue={homeScore}
                                    InputProps={{
                                        style: {
                                            width: '70px',
                                            height: '30px',
                                            borderRadius : '30px',
                                            color : 'white',
                                            fontSize : '1.2em',
                                        },
                                    }}
                                    inputProps={{ 
                                        style: {
                                        textAlign: 'center',
                                        },
                                    }}
                                    onChange={handleChangeScore}
                                />
                            &nbsp; - &nbsp;
                                <TextField 
                                    name="awayScore" 
                                    variant="outlined"
                                    defaultValue={awayScore}
                                    InputProps={{
                                        style: {
                                            width: '70px',
                                            height: '30px',
                                            borderRadius : '30px',
                                            color : 'white',
                                            fontSize : '1.2em',
                                        },
                                    }}
                                    inputProps={{ 
                                        style: {
                                        textAlign: 'center',
                                        },
                                    }}
                                    onChange={handleChangeScore}
                                /></Box>}
                        </Item>
                        {match.discipline === 'rugby' && <React.Fragment>
                        <Typography sx={{background : '#4973AE', color : 'white'}}>dont essais :</Typography>
                        <Item sx={{background : '#4973AE', color : 'white'}}>
                                    <Box sx={{mb : 1}}>
                                <TextField
                                    sx={{
                                        "& .MuiInputBase-input.Mui-disabled": {
                                          WebkitTextFillColor: "darkgrey",
                                      }
                                    }}
                                    disabled={homeScore < 5}
                                    name="homeEssais" 
                                    variant="outlined"
                                    defaultValue={homeEssais}
                                    InputProps={{
                                        style: {
                                            width: '60px',
                                            height: '25px',
                                            borderRadius : '30px',
                                            color : 'white',
                                            fontSize : '1.1em',
                                        },
                                    }}
                                    inputProps={{ 
                                        style: {
                                        textAlign: 'center',
                                        },
                                    }}
                                    onChange={handleChangeEssais}
                                />
                            &nbsp; - &nbsp;
                                <TextField 
                                    sx={{
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: "darkgrey",
                                    },
                                    }}
                                    disabled={awayScore < 5}
                                    name="awayEssais" 
                                    variant="outlined"
                                    defaultValue={awayEssais}
                                    InputProps={{
                                        style: {
                                            width: '60px',
                                            height: '25px',
                                            borderRadius : '30px',
                                            color : 'white',
                                            fontSize : '1.1em',
                                        },
                                    }}
                                    inputProps={{ 
                                        style: {
                                            textAlign: 'center',

                                        }
                                    }}
                                    onChange={handleChangeEssais}
                                />
                                </Box>
                        </Item>
                        </React.Fragment>}
                    </Box>
                    
                </Grid>
                <Grid item xs={3.5} sx={{overflow : 'hidden'}}>
                    <Item sx={{background : match.awayTeam.color, color : match.awayTeam.textColor, display : 'flex', flexDirection : 'row', justifyContent : 'space-around'}}>
                        <Grid container sx={{alignItems : 'center'}}> 
                        <Grid item xs={3}>
                                {match.awayTeam.logoUrl && <img src={match.awayTeam.logoUrl} style={{height : '30px'}}></img>}
                            </Grid>
                            <Grid item xs={9}>
                                <Typography gutterBottom  component="div" variant={'body2'}>{match.awayTeam.name}</Typography>
                            </Grid>
                            
                        </Grid>
                    </Item>
                </Grid>
                <Grid item xs={12} sx={{paddingTop : 1, flexDirection : 'column', justifyContent : 'flex-start', display : 'flex', alignItems : 'center'}}>
                    <Box sx={{ marginBottom : 2}}>
                    {getPeriodButton()}
                    </Box>
                    

                    <Button  variant="contained" onClick={pressTimerButton} color={getColorButton()} disabled={timerValue === 0 && match.statusTimer === 'off'} size="large" sx={{width : '60%'}}><Typography sx={{fontSize : '1em'}}>{getTimer()}</Typography></Button>
                </Grid>
            </Grid>
          </Box>
        </Box>
    
      );

}, (prevProps, nextProps) => {

    if(prevProps.match.gameFacts.length !== nextProps.match.gameFacts.length)
        return false

    return prevProps.match.gameFacts.every(prevFact => nextProps.match.gameFacts.some(nextFact => prevFact._id === nextFact._id)) &&
    prevProps.match.timer === nextProps.match.timer && 
    prevProps.match.period === nextProps.match.period && 
    prevProps.match.statusTimer === nextProps.match.statusTimer && 
    prevProps.match.status === nextProps.match.status;
  });

export default LiveMultiplexScore